import React from "react";
import { Table } from "antd";

interface WorkInfoSectionProps {
  services?: any[];
}

const workColumns = [
  { title: "S.No", dataIndex: "sno", key: "sno", width: 60 },
  { title: "Task Title", dataIndex: "taskTitle", key: "taskTitle", width: 200 },
  {
    title: "Work Category",
    dataIndex: "workCategoryName",
    key: "workCategoryName",
    width: 180,
  },
  { title: "Work Type", dataIndex: "workType", key: "workType", width: 120 },
  { title: "Quantity", dataIndex: "quantity", key: "quantity", width: 100 },
  { title: "UOM", dataIndex: "uomName", key: "uomName", width: 80 },
  { title: "Description", dataIndex: "description", key: "description", width: 200 },
];

const WorkInfoSection: React.FC<WorkInfoSectionProps> = ({ services }) => {
  const dataSource = (services || []).map((item, idx) => ({
    key: idx,
    sno: idx + 1,
    taskTitle: item.taskTitle || "--",
    workCategoryName: item.workCategoryName || "--",
    workType: item.workType || "--",
    quantity: item.quantity || "--",
    uomName: item.uomName || "--",
    description: item.description || "--",
  }));

  return (
    <div style={{ marginBottom: 32 }}>
      <Table
        columns={workColumns}
        dataSource={dataSource}
        pagination={false}
        bordered
        size="middle"
        style={{ background: "white" }}
        scroll={{ x: true }}
        locale={{
          emptyText: (
            <span style={{ color: "#888" }}>No work/service items found.</span>
          ),
        }}
      />
    </div>
  );
};

export default WorkInfoSection;
